const e=async(e,t,n,r)=>{let{data:i}=await e.get(`/orgs/${t}/users/${n}/apps`,{params:r});return i};export{e as getUserApps};
//# sourceMappingURL=get-user-apps.mjs.map